<template>
  <div class="contais">
    <div class="content">
      <div class="content_heads">
        <h2>房产业务预审批建当</h2>
      </div>
      <!-- 内容 -->
      <div class="content_m">
        <!-- 第一页 -->
        <table width="90%" v-if="showTable == 1">
          <tr>
            <td width="20%">抵押顺序</td>
            <td colspan="3">
              <!-- <input type="text" class="input_text" v-model="Dyorder" /> -->
               <el-dropdown trigger="click" @command="DyOrder">
                <span class="el-dropdown-link">
                  {{Dyorder}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="第一抵押顺位">第一抵押顺位</el-dropdown-item>
                  <el-dropdown-item command="第二抵押顺位">第二抵押顺位</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </td>
            <td width="20%">典当额度</td>
            <td><input type="text" class="input_text" v-model="Ddedquota" /></td>
          </tr>
          <tr>
            <td>当户</td>
            <td colspan="3"><input type="text" class="input_text" v-model="Dhname" /></td>
            <td>电话</td>
            <td><input type="text" class="input_text" v-model="tel" /></td>
          </tr>
          <tr>
            <td>证件号码</td>
            <td colspan="3">
              <input type="text" class="input_text" v-model="Cardnumber" />
            </td>
            <td>当票编号</td>
            <td>后续补充</td>
          </tr>
          <tr>
            <td>典当期限</td>
            <td colspan="3">
              <!-- <input type="text" class="input_text" v-model="Ddqxdeadline"> -->
              <el-date-picker
                v-model="DateValue"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                class="picker"
              >
              </el-date-picker>
            </td>
            <td>分期还本</td>
            <td><input type="text" class="input_text" v-model="fqhbStaging" /></td>
          </tr>
          <tr>
            <td>担保日期</td>
            <td colspan="5">
              <el-date-picker
                v-model="DbDatevalue"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                >
              </el-date-picker>
            </td>
          </tr>
          <tr>
            <td>月综合费率/%</td>
            <td width="15%">
              <input type="text" class="input_text" v-model="ZhfPrice" />
            </td>
            <td width="15%">月利息费率/%</td>
            <td width="15%"><input type="text" class="input_text" v-model="lx" /></td>
            <td>每月还本</td>
            <td><input type="text" class="input_text" v-model="Hbalso" /></td>
          </tr>
          <tr>
            <td>房产地址</td>
            <td colspan="5">
              <input type="text" class="input_text" v-model="Fcaddres" />
            </td>
            
          </tr>
          <tr>
            <td>他项权证</td>
            <td colspan="3" >
              <!-- <input type="text" class="input_text" v-model="TxqzWarrant"> -->
              <el-upload
                class="upload-demo"
                action="#"
                :http-request="upload"
                :data="{ isName: 'TxqzWarrant' }"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                multiple
                :limit="1"
                :on-exceed="handleExceed"
                :file-list="fileList"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
              </el-upload>
            </td>
            <td>抵押方式</td>
            <td>
              <!-- <input type="text" class="input_text" v-model="DyfsGuaranty" /> -->

              <el-dropdown trigger="click" @command="DyfsGuaranTy">
                <span class="el-dropdown-link">
                  {{DyfsGuaranty}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="一般抵押">一般抵押</el-dropdown-item>
                  <el-dropdown-item command="最高额度抵押">最高额度抵押</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </td>
          
          </tr>
          <tr>
            <td rowspan="4">转账支付（指示支付）</td>
            <td>户名</td>
            <td colspan="3"><input type="text" class="input_text" v-model="HmName" /></td>
             <td>需要特批事项</td>
          </tr>
          <tr>
            <td>开户行</td>
            <td colspan="3"><input type="text" class="input_text" v-model="KhBank" /></td>
             <td rowspan="3">
              <input type="textarea" class="input_text" v-model="Special" />
            </td>
          </tr>
          <tr>
            <td>账号</td>
            <td colspan="3">
              <input type="text" class="input_text" v-model="Account" />
            </td>
          </tr>
          <tr>
            <td>其他方式</td>
            <td colspan="3"><input type="text" class="input_text" v-model="other" /></td>
          </tr>
        </table>
        <!-- 第二页 -->
        <table width="90%" v-if="showTable == 2">
          <tr>
            <td width="20%">一抵情况</td>
            <td colspan="2">
              <input type="text" class="input_text" v-model="OneMortgage" />
            </td>
          </tr>
          <tr>
            <td width="20%">二抵情况</td>
            <td colspan="2">
              <input type="text" class="input_text" v-model="TwoMortgage" />
            </td>
          </tr>
          <tr>
            <td width="20%">收集受理资料</td>
            <td>
              <!-- {{Material==""?'未确认':Material}} -->
              <!-- 上传文件 -->
              <el-upload
                class="upload-demo"
                action="#"
                :http-request="upload"
                :data="{ isName: 'Material' }"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                multiple
                :limit="3"
                :on-exceed="handleExceed"
                :file-list="fileList"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
              </el-upload>
            </td>
            <td width="10%">(由业务经办人收齐确认)</td>
          </tr>
          <tr>
            <td width="20%">合同合规审核</td>
            <td>
              <!-- {{ContractReview==""?'未确认':ContractReview}} -->
              <el-upload
                class="upload-demo"
                action="#"
                :http-request="upload"
                :data="{ isName: 'ContractReview' }"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                multiple
                :limit="1"
                :on-exceed="handleExceed"
                :file-list="fileList"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
              </el-upload>
            </td>
            <td width="10%">(由法务确认)</td>
          </tr>
          <tr>
            <td width="20%">合同签订</td>
            <td>
              <!-- <span v-if="ContractSigning!==''"><button>查看合同</button></span>
                            <span v-else>待签订</span> -->
              <el-upload
                class="upload-demo"
                action="#"
                :http-request="upload"
                :data="{ isName: 'ContractSigning' }"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                multiple
                :limit="1"
                :on-exceed="handleExceed"
                :file-list="fileList"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
              </el-upload>
            </td>
            <td width="10%">(由总经理负责面签，是否发放当金最终以签订当票为准)</td>
          </tr>
          <tr>
            <td width="20%">实地调查</td>
            <td>
              <!-- <span v-if="FieldTrips!==''"><button>查看调查文件</button></span>
                            <span v-else>调查资料未上传</span> -->
              <el-upload
                class="upload-demo"
                action="#"
                :http-request="upload"
                :data="{ isName: 'FieldTrips' }"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                multiple
                :limit="1"
                :on-exceed="handleExceed"
                :file-list="fileList"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
              </el-upload>
            </td>
            <td width="10%">(房屋与房产证记载是否一致，房屋现状及使用是否异常)</td>
          </tr>
          <tr>
            <td width="20%">抵押入押</td>
            <td>
              <!-- <input type="text" class="input_text" v-model="Confirm"> -->
              <el-upload
                class="upload-demo"
                action="#"
                :http-request="upload"
                :data="{ isName: 'Confirm' }"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                multiple
                :limit="1"
                :on-exceed="handleExceed"
                :file-list="fileList"
              >
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </td>
            <td width="10%">(不动产登记证明内容与房屋抵押后查档记载的信息是否一致)</td>
          </tr>
        </table>

        <!-- 第三页 -->
        <table width="90%" v-if="showTable == 3">
          <tr>
            <td colspan="3">完成以上2步业务流程呈总经理审批发放当金</td>
          </tr>
          <tr>
            <td width="20%">财务室</td>
            <td>{{ Finance == "" ? "待确认" : Finance }}</td>
            <td width="10%">（注意管理办法对当金放款的限制和费率的规定）</td>
          </tr>
          <tr>
            <td>总经理审批放款</td>
            <td colspan="3">
              {{ Ratify == "" ? "待批准" : Ratify }}
            </td>
          </tr>
          <tr>
            <td>开票出纳</td>
            <td>{{ Cashier == "" ? "待确认" : Cashier }}</td>
            <td>（总经理签名批款后，才能出当票、支付当金）</td>
          </tr>
        </table>
      </div>
      <div class="box_btn">
        <div>
          <el-button type="primary" v-if="showTable == 3" @click="CreateBusiness"
            >创建业务</el-button
          >
        </div>

        <div>
          <el-button-group>
            <el-button type="primary" icon="el-icon-arrow-left" @click="DecRease"
              >上一步</el-button
            >
            <el-button type="primary" @click="ToNext"
              >下一步<i class="el-icon-arrow-right el-icon--right"></i
            ></el-button>
          </el-button-group>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
const COS = require("cos-js-sdk-v5");
const cos = new COS({
  SecretId: "AKID1pOghRu62i7G8j36sOddMoztXv2tUord", // 身份识别ID
  SecretKey: "YjdHfndCUVGjwta091cwzmIXVBbkcEag", // 身份秘钥
});
export default {
  name: "createhouse",
  data() {
    return {
      showTable: 1,

      Dyorder: "选择抵押顺序", //典当顺序
      Ddedquota: "", //典当额度
      Dhname: "", //当户名字
      tel: "", //电话
      Cardnumber: "", //身份证号码
      // Ddqxdeadline:"", //典当期限
      fqhbStaging: "", //分期还本
      ZhfPrice: "", //综合费
      lx: "", //利息
      Hbalso: "", //还本
      Fcaddres: "", //房产地址
      TxqzWarrant: [], //他项权证
      DyfsGuaranty: "选择抵押方式", //抵押方式
      Special: "", //特批事项
      HmName: "", //户名
      KhBank: "", //开户行
      Account: "", //账号
      other: "", //其他
      OneMortgage: "", //一抵情况
      TwoMortgage: "", //二抵情况
      Material: [], //收集受理资料

      ContractReview: [], //合同审核
      ContractSigning: [], //合同签订
      FieldTrips: "", //调查资料
      Confirm: [], //抵押确认

      Finance: "", //财务
      Ratify: "", //经理批准
      Cashier: "", //出纳

      CreateDate: "", //创建日期
      CreateUser: "", //经办人
      Review: "", //复核人

      DateValue: "",



      //选择日期
      pickerOptions: {
        shortcuts: [
          {
            text: "30天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 29);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },

      Imgs: [], //物品图片
      uploadnum: "", //上传进度
      fileList: [],

      DbDatevalue:"", //担保日期

    };
  },
  methods: {
 
    // 下一页
    ToNext() {
      if (this.showTable < 3) {
        if (this.DateValue == "") {
          return this.$message({
            message: "未选择典当期限，请先选择典当日期",
            type: "warning",
          });
        }
        this.showTable = this.showTable + 1;
      } else {
        this.$message({
          message: "已经是最后一页",
          type: "warning",
        });
      }
    },
    //上一页
    DecRease() {
      if (this.showTable > 1) {
        this.showTable = this.showTable - 1;
      } else {
        this.$message({
          message: "已经是第一页",
          type: "warning",
        });
      }
    },
    //element 上传方法
    upload(res) {
      console.log(res.data.isName);
      if (res.file) {
        // 执行上传操作
        cos.putObject(
          {
            Bucket: "changan-1259114000" /* 存储桶 */,
            Region: "ap-guangzhou" /* 存储桶所在地域，必须字段 */,
            Key: res.file.name /* 文件名 */,
            StorageClass: "STANDARD", // 上传模式, 标准模式
            Body: res.file, // 上传文件对象
          },
          (err, data) => {
            
            // 上传成功之后
            if (data.statusCode == 200) {
              this[res.data.isName].push("https://" + data.Location);

              console.log("https://" + data.Location);
            }
          }
        );
      }
    },

    handlePreview(file) {
      console.log(file);
    },
    //删除上传图片
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    //确定删除上传的图片
    beforeRemove(file) {
      this.$confirm(`确定移除 ${file.name}？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          cos
            .deleteObject({
              Bucket: "changan-1259114000" /* 填入您自己的存储桶，必须字段 */,
              Region: "ap-guangzhou" /* 存储桶所在地域，例如ap-beijing，必须字段 */,
              Key:
                file.name /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */,
            })
            .then(() => {
              this.$message({
                showClose: true,
                message: "文件删除成功",
                type: "success",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //限制上传的文件数量
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    //创建业务
    CreateBusiness() {
        console.log(this.Material)
      if (this.Dhname && this.Account !== "") {
        this.axios
          .post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query: `db.collection("house").add({
                        data:{
                            Dyorder:"${this.Dyorder}", 
                            Ddedquota:"${this.Ddedquota}", 
                            Dhname:"${this.Dhname}", 
                            tel:"${this.tel}",
                            Cardnumber:"${this.Cardnumber}",
                            Piaonumber:"",
                            DdqxStartDate:"${this.DateValue[0]}", 
                            DdqxEndDate:"${this.DateValue[1]}",
                            fqhbStaging:"${this.fqhbStaging}",  
                            ZhfPrice:"${this.ZhfPrice}", 
                            lx:"${this.lx}", 
                            Hbalso:"${this.Hbalso}", 
                            Fcaddres:"${this.Fcaddres}", 
                            TxqzWarrant:"${this.TxqzWarrant[0]}", 
                            DyfsGuaranty:"${this.DyfsGuaranty}", 
                            Special:"${this.Special}", 
                            HmName:"${this.HmName}", 
                            KhBank:"${this.KhBank}", 
                            Account:"${this.Account}", 
                            other:"${this.other}", 
                            OneMortgage:"${this.OneMortgage}", 
                            TwoMortgage:"${this.TwoMortgage}", 
                            Material:"${this.Material}", 
                            ContractReview:"${this.ContractReview}", 
                            ContractSigning:"${this.ContractSigning}", 
                            FieldTrips:"${this.FieldTrips}", 
                            Confirm:"${this.Confirm}", 
                            Finance:"${this.Finance}", 
                            Ratify:"${this.Ratify}",  
                            Cashier:"${this.Cashier}", 
                            CreateDate:"${this.CreateDate}",
                            CreateUser:"${this.CreateUser}",
                            ReviewDate:"",
                            Review:"",
                            State:"在当",
                            DbDatevalue:"${this.DbDatevalue}"
                        }
                    })`,
          })
          .then((res) => {
            console.log(res);

            if (res.data.errmsg == "ok") {
              this.$notify({
                title: "业务创建成功",
                message: "业务已创建成功，请到复核处查看业务",
                type: "success",
              });
              setTimeout(() => {
                this.$router.go(0);
              }, 2000);
            } else {
              this.$notify.error({
                title: "业务创建失败",
                message: res.data.errmsg,
              });
            }
          });
      } else {
        this.$message({
          message: "请把表单填写完整",
          type: "warning",
        });
      }
    },

    //选择抵押顺序事件
    DyOrder(event){
      this.Dyorder = event
    },
    //选择抵押方式
    DyfsGuaranTy(event){
      this.DyfsGuaranty = event
    }
    // },
  },

  created() {
    //获取到this.ACCESS_TOKEN
    this.getTokens();

    //获取当前登录的用户数据
    this.getUserToken();

    //获取今天的日期
    this.CreateDate = dayjs().format("YYYY-MM-DD HH:mm:ss");
    //
 
  },

  mounted() {
    setTimeout(() => {
      this.CreateUser = this.userData.username;
    }, 800);
  },
};
</script>
<style scoped>
.content {
  width: 90%;
  /* height: 50vh; */
  background-color: #ffffff;
  margin: 50px auto;
  padding: 0 0 10px 0;
  box-shadow: 0 0 9px 0 #00000044;
}
.content_heads {
  width: 100%;
  height: 60px;
  background-color: #eeeeed;
  box-shadow: 0 0 9px 0 #00000044;
  border: 1px solid #c5c5c5;
  /* text-align: center; */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.content_m {
  margin: 50px auto;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
}
table {
  border-collapse: collapse;
}
td {
  height: 50px;
  border: 1.5px solid black;
  font-size: 15px;
  text-align: center;
  font-weight: bold;
}
.box_btn {
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.input_text {
  /* border-style: none; */
  width: 98%;
  height: 98%;
  text-align: center;
  border: 0;
    outline: none;
     font-size: 15px;
     font-weight: bold;

}
.picket {
  width: 100%;
  outline: none;
  border: 0;
}
</style>
